<template>
  <div class="inners">
    <div class="left">
      <div class="flex" @click="toEditUserInfo">
        <img
            width="20"
            height="20"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAU9JREFUOE+l1LsublEUxfEfDUoNEU8gOucREJcQicsLKE+JgkShJCFKEqXecU0kbi8g4gUkGrWecGTK2sm2823f3sx6rf8aY465Zov6NY597GC1eL2lJi9gB2hL9zawnGfUAY4l2BvmsYY+fIFWBWawdhxiGl24SdB1rITSKsBR/EMoe0Q/dvEX3bhO0CVsNQPmYZO4xwX+pFAWcYRhbGPhO2ARFvaiOnGJATyhN0Hn8FoGzGDvmEi9yofZgwd05GFlPRxJjS+DRTDR03g07H4qy14rKmwGi/mLlAN2nGAvZXM4iFOEsggg0stXU1jR8jlC4RCufgIrAiO5UNmK/zlgKIuexXCfYBZfbJZZbgSsBStTGEOaKYzBraSsUcpniG1SrAhq5jubZZbjj06lHmZnnrFXFVZ1OdRamdlgb6a/Wetyg8N3GfA2bZDfAm8/AIZIVWxiy9xbAAAAAElFTkSuQmCC"
        />
      </div>
      <div class="bottoms">
        <div class="avactor">
          <div>
            <el-avatar
                :size="100"
                shape="square"
                :src="companyInfo.logo?companyInfo.logo:require('@/assets/default/com.png')"
            />
          </div>
          <div>
            {{ companyInfo.name }}
          </div>
          <div>{{ companyInfo.alias }}</div>
          <div
              style="width: 95%; margin: 20px auto; border-bottom: 1px solid #e8e8e8"
          ></div>
        </div>
        <div class="set_tool">
          <div><span><img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAeNJREFUWEftmL1qAkEQx//TRO4glYKCLyCkSWXyEGnEStKIRQpJ/ADBZxAEPwIWKcQmWIlN3iGJVZqAPoCgoE2Ce5pmwi4RRC7eRjxzxW1xB7f/nfntMLs3u4SfxswnlmXdALgGcMbMp+s+N95E9AngHcCjYRgPRPQl/ZB8CCGizPwE4NwN5xo234joyjTNMcnICCFe/xFmzftmmuYFCSFumfleYxauS4joTgI9M/Ol6940HBDRiwT6cDuBNViURCY6LRYL1h1wDJ020Gq1wnA4hGVZf+IyDAOxWAyBQEBrnBbQbDZDNpvFZDLRMrotikQiaLVaCIVCjuO1gDqdDtrttq2xQqGAeDyu+gaDAer1uq0uk8kgnU4fBqjRaKDX6zka2yVIJpPI5/OONrQitAlUq9UQDocdDUvBdDpFsVhUWteAut0uotGoFtB4PEYqlfKBfo2WHyGnRPIj5EdoHYHNjdHfh+zyYjNC5XIZwWDQKX1U/3w+R6VScXen1iKxEbn2L9v2RURIJBLqc7/fB7N9AXo0IFkLVatVBVQqlVRNZNcOCrSrQJP51Gw2FUMul1N5Y9cOWqB5roSVM14ulxiNRt4o8vddWfuM895B0YtHaW9dNnjuOkYmnqcurNYrwStXet8BwLigBWlEtQAAAABJRU5ErkJggg=="/></span><span
              v-if="companyInfo.phone!==null">{{ companyInfo.phone }}</span><span v-else>
            <el-button type="primary"
                       link
                       @click="bindPhone">
              {{ $t('common.goto.bind') }}
            </el-button>
          </span>
          </div>
          <div>
            <span><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAe9JREFUWEftmL9rIkEUx78PJbgLFiJioY21zWETK+20SWNtK6liZ60o+BfYHbbWNtdo5w9I0kgaO8HKQkSEhJ2FoLxjJAsJl2SGcze3R9xit3jffd/PvHn7Y4bwcjDzhW3b1wDKANLMHHZiXlyJ6AnAHEDPMIyfRPQsfUiehBAJZv4F4IcX5ho5H4joyjTNFcnKCCHu/yGMw/tgmuYlCSFumLmjMQrPJURUlUC3zJz13E3DgIjuJNCj1w2swXKUyEYny7JY94av0J2BVFX+/yo0HA6xWq1UA9OKJxIJFAqFT7XKCuXzeTC70/dEhNFodBpQLpc7JgiHw8hm/+51tVgssFwuj3nG47E7QDJLuVxGpVJBIBDQmiIpmk6naLfbsCzLfSCZMZPJoNFoIBKJfAp1OBzQ7XbR6/Xe6FytkJM5Fouh1WohnU6/C7Xb7dBsNjGbzf6IewIkXYLBIKrVKkql0hvT+XyOer2OzWbzLqxnQI6bfIxrtRpCoRD6/T46nQ72+/2H0+k5kHROpVJIJpOYTCbKZv8SICXFK8EZSFWtc4W+X4WKxSJs21YNXCtuGAYGg8FpH9f1eo3tdqtlqBJFo1HE4/HTgFQmbseVP2huG6ry+Q/IdwtFPy6l/bXZ4LvtGNn1vtqwch5Dv2zp/QbXkD2golKThQAAAABJRU5ErkJggg=="
                alt=""/></span
            >
            <span v-if="companyInfo.email!==null">{{ companyInfo.email }}</span>
            <span v-if="companyInfo.email!==null">
<!--              <el-button link type="primary" @click="toCancelBindEmail"-->
              <!--              >去解绑-->
              <!--            </el-button-->
              <!--            >-->
            </span>
            <span v-else>
            <el-button link type="primary" @click="toSetEmail"
            >{{ $t('common.goto.bind') }}
            </el-button
            >
            </span>
          </div>
          <div><span><img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAdtJREFUWEftWDFrwkAYfZ9DwUAREVwq6Ch26dYiuIku/QPavYstOrsLjoII0kmEOjn2F7i03XQogrNO4tLiRQrylQuNWLDJtRqbYjIkJN/Lfe/evbvkPsLnwcxHuq5fA7gCcMrMx2bMiSsRvQF4AXDv9/vviOhd5iF5EkKcMPMDgDMnkiu02SeiS03TJiSVEUI8/yEZk29f07RzEkLcMHNdoReOQ4joVhJ6ZOYLx7MpJCCiJ0no1WkDK3AxINLoNJ/PWfWFfeA8QnYqKylUr9fR7XbBbD26yWQS1WrVLqdlXIlQPp/HeDxWStTr9ZRw34E8Qnby/U+FcrkcJpOJ0blarYZwOLzq6GKxQKFQgK7rxjPpoVarhdFotML4fD5ks1mkUik7gaCk0DqheDyOQCDwhdBgMFjdS0LreDMQi8XQbrd3Q+ins2wTPhKJoNPpHAAhFQ9JhdLpNDKZDEyPhUKh3Sn0Gw8tl0tEo1GDkPTY4QyZnSvlLNurqT0PbRoSbx2yMupwOES5XMZsNrPzsxEvlUpoNpvGdF8/5DpUqVSQSCS2+0ErFouYTqdKZOxAwWAQjUZjO0J2SXYdV/ra7zqpVXvu2yi6cSvtrmKD68ox0mCuKliZjndLSe8DfgnNoOjBOnAAAAAASUVORK5CYII="/></span>{{
              companyInfo.country
            }}
          </div>
        </div>
        <div class="userInfo_message" v-loading="leftLoading">
          <div class="message_info_item" v-for="item in messageInfo" :key="item.id" @click="handleClickDetail(item)">
            <div class="items">
              <div class="left_text">
                <span><img :src="getItemIcon(item.id)" :class="{'icon-small': item.id === 3 || item.id === 4}"/></span><span class="texts">{{ item.name }}</span>
              </div>
              <div class="right_text">
                <span>
                  <template v-if="item.id!==2">{{ item.sum }}</template><!--
                  --><template v-else>{{ spaceSizeFormat(item.sum, false) }}</template>/<span style="color: red"><!--
                    --><template v-if="item.id!==2">{{ item.allCount }} {{ item.units }}</template><!--
                    --><template v-else>{{ spaceSizeFormat(item.allCount) }}</template><!--
                  --></span>
                </span>
                <el-icon>
                  <ArrowRightBold/>
                </el-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="titles" style="margin-bottom: 20px">{{ $t('common.qyzh') }}</div>
      <div class="line-text">{{ $t('common.exclusive') }}</div>
      <!-- vip 信息 -->
      <VipMemberInfo
        :isVip="isVipUser"
        :expireDate="userInfo?.vipExpireDate"
        :price="vipUpsellPrice"
        @action="handleVipAction"
      />
      <!-- <div style="display: flex;justify-content: space-between"> -->
        <!-- <VipTab :memberType="memberType"></VipTab> -->
      <!-- </div> -->
      <div class="line-text">{{ $t('userinfo.vip.server.project') }}</div>
      <div style="display: flex;justify-content: space-between">
        <VipProduct @openInvite="handleOpenInviteDialog"></VipProduct>
      </div>
    </div>
    <InviteFriendDialog
        v-model="inviteDialogVisible"
        :user-info="userInfo"
        :resource-options="inviteResourceOptions"
        :default-resource="inviteDefaultResource"
        :on-generate="handleGenerateInviteLink"
        :on-send-email="handleSendInviteEmail"
        @generate="handleGenerateInviteLink"
        @send-email="handleSendInviteEmail"
    />
  </div>
</template>

<script setup>
import {onMounted, computed, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {getCompanyQueryById} from "@/api/usercenter";
import {ElMessage} from "element-plus";
import {i18n} from "@/lang";
import {spaceSizeFormat} from "@/utils/file";
import VipTab from "@/views/UserCenter/component/VipTab.vue";
import VipProduct from "@/views/UserCenter/component/VipProduct.vue";
import VipMemberInfo from "@/views/UserCenter/component/VipMemberInfo.vue";
import InviteFriendDialog from "@/components/InviteFriendDialog/index.vue"
import {ArrowRightBold} from "@element-plus/icons-vue";

const router = useRouter();
const store = useStore()

const userInfo = computed(() => store.state.user.userInfo)
// 判断是否是企业主账号？
const isEnterpriseMainUser = computed(() => store.state.user.isEnterpriseMainUser);

const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)
const toEditUserInfo = () => {
      router.push({path: "/personal/editInfo", query: {isQ: 1}});
    }
;

const toSetEmail = () => {
  router.push("/personal/setemail");
};
const toCancelBindEmail = () => {
  router.push({path: "/personal/setemail", query: {email: userInfo.value.email}});
}
const toCheckUser = () => {
  router.push("/personal/realName");
};

// ---------------------
// 详情
const clickTargetTo = () => {
  router.push('/personal/station')
}
const clickTargetToSave = () => {
  router.push('/personal/storeDetails')
}
const clickTargetToFlow = () => {
  router.push('/personal/flowDetails')
}

const bindPhone = () => {
  router.push('/personal/setphone')
}
// -------------

// 获取公司相关信息
const companyInfo = ref({})
const getCompanyInfo = async () => {
  const companyId = JSON.parse(window.localStorage.getItem('userInfo')).companyId;
  const res = await getCompanyQueryById({
    id: companyId
  })
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  companyInfo.value = res.result;
  // 存储公司相关信息
  window.localStorage.setItem('companyInfo', JSON.stringify(res.result))
}

const spaceSize = computed(() => store.state.cloud.spaceSize)
const leftLoading = ref(false)

const companyInformation = computed(() => store.state.user.companyInformation)

const isVipUser = computed(() => store.getters['user/isVipUser'])
// 会员选择 主要 ！！！
const memberType = computed(() => {
      // isVip 1,2,3
      // product 6,7,8
      if (isVipUser.value) {
        return userInfo.value.isVip * 1 + 5
      } else {
        return 5
      }
    }
)

const allUserVip = computed(() => store.state.buystorage.allUserVip)

const vipUpsellPrice = computed(() => {
  const n = Number(store.state.buystorage.vipUpsellPrice ?? 0)
  return Number.isFinite(n) ? n : 0
})

const handleVipAction = (val) => {
  const vipList = allUserVip.value || []

  if (isVipUser.value) {
    const current = vipList.find(v => v.productSort === memberType.value)
    const query = {
      ...(current?.id ? {indexId: current.id} : {}),
      ...(current?.productSort ? {productSort: current.productSort} : {productSort: memberType.value}),
      type: 2,
    }
    if (val) {
      query.indexId = 9
    }
    router.push({
      path: '/personal/buystorage',
      query: query
    })
    return
  }

  const defaultVip = vipList.find(v => v.productSort >= 6 && v.productSort <= 8) || vipList[0]
  const query = {
    ...(defaultVip?.id ? {indexId: defaultVip.id} : {}),
    productSort: defaultVip?.productSort || 6,
    type: 1,
  }
  if (val) {
    query.indexId = 9
  }
  router.push({
    path: '/personal/buystorage',
    query: query
  })
}

const inviteDialogVisible = ref(false)
const inviteDefaultResource = ref('')
const inviteResourceOptions = computed(() => {
  const list = Array.isArray(store.state.buystorage?.allProductList) ? store.state.buystorage.allProductList : []
  return list.map((it) => ({
    label: `${getProductLabel(it)} ${getProductUnitText(it)}`.trim(),
    value: String(it?.id ?? '')
  })).filter(it => it.value)
})

const getProductLabel = (item) => {
  const sort = Number(item?.productSort)
  if (sort === 1) return i18n.global.t('userinfo.vip.service.1')
  if (sort === 2) return i18n.global.t('userinfo.vip.service.2')
  if (sort === 3) return i18n.global.t('userinfo.vip.service.3')
  if (sort === 4) return i18n.global.t('userinfo.vip.service.4')
  return ''
}

const getProductUnitText = (item) => {
  const sort = Number(item?.productSort)
  if (sort === 1) return i18n.global.t('common.text.per.station.year', {number: item?.productNum})
  if (sort === 2) return i18n.global.t('common.text.per.GB.year', {number: spaceSizeFormat(item?.productNum, false)})
  if (sort === 3) return i18n.global.t('common.text.per.feng.year', {number: item?.productNum})
  if (sort === 4) return i18n.global.t('common.text.per.year', {number: item?.productNum})
  return ''
}

const handleOpenInviteDialog = (item) => {
  inviteDefaultResource.value = String(item?.id ?? '')
  inviteDialogVisible.value = true
}

const handleGenerateInviteLink = async () => {
  const invitedCode = String(userInfo.value?.guid ?? '')
  const selectedId = String(inviteDefaultResource.value ?? '')
  const list = Array.isArray(store.state.buystorage?.allProductList) ? store.state.buystorage.allProductList : []
  const selected = list.find(it => String(it?.id ?? '') === selectedId)
  const invitedProductId = selected?.productSort != null ? String(selected.productSort) : ''
  const base = `${window.location.origin}/companyRegister`
  const params = new URLSearchParams()
  if (invitedCode) params.set('invitedCode', invitedCode)
  if (invitedProductId) params.set('invitedProductId', invitedProductId)
  const qs = params.toString()
  return qs ? `${base}?${qs}` : base
}

const handleSendInviteEmail = async ({ link }) => {
  console.log('send invite email with link:', link)
}

const messageInfo = computed(() => [
  {
    id: 1,
    name: i18n.global.t('common.seat'),
    sum: companyInformation.value.freePosition,
    allCount: companyInformation.value.totalPosition,
    units: i18n.global.t('common_ph22')
  },
  {
    id: 2,
    name: i18n.global.t('common.space'),
    sum: companyInformation.value.freeLocation,
    allCount: companyInformation.value.effectiveLocation,
    units: ""
  },
  {
    id: 3,
    name: i18n.global.t('userinfo.vip.edm'),
    sum: companyInformation.value?.freeEdmNum,
    allCount: companyInformation.value?.edmTotalNum,
    units: i18n.global.t('common_ph23')
  },
  {
    id: 4,
    name: i18n.global.t('userinfo.vip.AI'),
    sum: companyInformation.value.freeAiNum?.toFixed(2),
    allCount: companyInformation.value.totalAiNum?.toFixed(2),
    units: i18n.global.t('common_ph24')
  }
])


onMounted(async () => {
  try {
    leftLoading.value = true
    if (store.state.buystorage.vipUpsellPrice === null || store.state.buystorage.vipUpsellPrice === undefined) {
      await store.dispatch('buystorage/getVipUpsellPrice')
    }
    await store.dispatch("buystorage/getMailProductListApis", 2)
    await getCompanyInfo()
    await store.dispatch("user/getCompanyCurrentInfoApis")
    // await store.dispatch("cloud/queryByUserIdApis")
    leftLoading.value = false
  } catch (e) {
    leftLoading.value = false
  }
})


// 详情跳转
const handleClickDetail = (item) => {
  // console.log(item, 'item')
  const {id} = item
  if (id === 1) {
    router.push('/personal/station?searchType=1')
  } else if (id === 2) {
    router.push('/personal/storeDetails?searchType=1')
  } else if (id === 3) {
    router.push(`/personal/edmDetails?searchType=1`)
  } else if (id === 4) {
    router.push('/personal/aiDetails?searchType=1')
  }
}

// 获取项目图标
const getItemIcon = (id) => {
  const icons = {
    1: require('@/assets/q1.png'),
    2: require('@/assets/q2.png'),
    3: require('@/assets/edm.png'),
    4: require('@/assets/AI.png')
  }
  return icons[id] || ''
}

</script>

<style lang="less" scoped>
@import "./less/Basic.less";

.inners {
  min-height: 820px !important;
}

:deep(.el-avatar) {
  cursor: pointer;
  background: #f3f3f3 !important;
}

:deep(.el-avatar) {
  background: #f3f3f3 !important;
}

:deep(.el-tabs__item) {
  margin-right: 30px;
  padding-top: 29px;
  padding-bottom: 29px;
  cursor: pointer;
  font-size: 18px;
}

:deep(.el-button) {
  font-size: 14px !important;
}

:deep(.el-table .cell) {
  font-size: 14px !important;
  font-weight: normal !important;
}

:deep(.el-progress-bar__inner) {
  border-radius: 0px !important;
}

:deep(.el-progress-bar__outer) {
  border-radius: 0px !important;
}

.font {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.line-text {
  width: 350px;
  display: flex;
  align-items: center;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #8B4127;
  margin: 20px auto;
}

.line-text::before,
.line-text::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #FCDEB9;
}

.line-text::before {
  margin-right: 8px;
}

.line-text::after {
  margin-left: 8px;
}

.left_box {
  div {
    margin-bottom: 10px !important;
  }
}

.icon-small {
  width: 16px !important;
  height: 16px !important;
}
</style>
